exports.components = {
  "component---node-modules-berlitz-gatsby-theme-blitz-prismic-franchise-src-templates-page-jsx": () => import("./../../../node_modules/@berlitz/gatsby-theme-blitz-prismic-franchise/src/templates/Page.jsx" /* webpackChunkName: "component---node-modules-berlitz-gatsby-theme-blitz-prismic-franchise-src-templates-page-jsx" */)
}

